import { Consultation, ConsultationType } from '@/core/models/consultation.model'
import { ChipProps } from '@mui/material'

/**
 * Count occurence of extension files
 * @param consultation Consultation Object
 * @param extArr Array of file extension
 * @returns a count (0 if empty)
 */
export function getFileCount(consultation: Consultation, extArr: Array<string>): number {
  let count = 0
  consultation.files.forEach((file) => {
    for (var i = 0; i < extArr.length; i++) {
      if (file.filename.endsWith(extArr[i])) {
        count += 1
      }
    }
  })
  return count
}

const liveStatus = ['scheduled', 'active', 'accepted']

interface ConsultationDatas {
  _id: string
  status: string
  type: string
}

export function redirectTo(consultation: ConsultationDatas): string {
  if (!liveStatus.find((status) => status === consultation.status)) return `/consultations/${consultation._id}`

  switch (consultation.type) {
    case ConsultationType.MeetingOnly:
      return `/consultations/${consultation._id}/meeting`
    case ConsultationType.Local:
      return `/consultations/${consultation._id}/local`
    default:
      return `/consultations/${consultation._id}/live`
  }
}

export function getStatusColor(status: string): ChipProps['color'] {
  switch (status) {
    case 'scheduled':
    case 'waiting':
      return 'primary'
    case 'accepted':
    case 'active':
      return 'success'
    case 'canceled':
    case 'refused':
      return 'error'
    default:
      return 'info'
  }
}
